import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import Dummy from "layouts/wrapper/Dummy";
import P from "layouts/wrapper/P";
import VerticalMiddleWrapper from "layouts/wrapper/VerticalMiddleWrapper";
import style from "./ModalBase.module.css"

function ModalBaseHeader({ title, modalClose }) {
    return (
        <div className={style.header}>
            <HorizontalFlex>
                <FlexChild justifyContent={"center"}>
                    <Dummy width={50}/>
                    <P font={"Cafe24Ohsquareair"} size={"min(4vw, 15px)"} >{title}</P>
                </FlexChild>
                <FlexChild width={50} justifyContent={"center"}>
                    <VerticalMiddleWrapper>
                        <a className={style.headerCloseButton} onClick={modalClose}>
                            {' '}&times;{' '}
                        </a>
                    </VerticalMiddleWrapper>
                </FlexChild>
            </HorizontalFlex>



        </div>
    );
}

export default ModalBaseHeader;